import { useNavigate } from "react-router-dom";
import { CaretLeft, CheckCircle } from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";
import { RedeemGiftCard } from "@/components/gift/RedeemGiftCard";

export default function RedeemGift() {
  const navigate = useNavigate();
  const { user } = useAuth();
  return (
    <div data-testid="redeem-page" className="mx-auto max-w-xl px-5 py-8 sm:py-12">
      <button data-testid="redeem-back" onClick={() => navigate("/timeline")}
        className="-ml-2 mb-6 flex min-h-[40px] items-center gap-1 rounded-full px-2 text-sm font-semibold text-[#2D2824] hover:bg-[#F4EFE6]">
        <CaretLeft size={16} /> Back to my journey
      </button>
      <h1 className="font-serif text-4xl text-[#2D2824]">Redeem a gift</h1>
      <p className="mt-2 leading-relaxed text-[#6E665E]">Someone who cares about you has given you Lifetime Access. Your diary stays completely private to you.</p>
      <div className="mt-6">
        {user?.is_pro ? (
          <div data-testid="redeem-already-pro" className="rounded-2xl bg-[#EAF1EE] p-5 text-[#4A6B5D]">
            <CheckCircle size={28} weight="duotone" />
            <p className="mt-2 font-medium">Lifetime Access is active on your account — every Life Season is open.</p>
            <button onClick={() => navigate("/timeline")} className="mt-4 rounded-full bg-[#36858B] px-6 py-3 text-sm font-semibold text-white hover:bg-[#245E63]">Go to my journey</button>
          </div>
        ) : (
          <RedeemGiftCard onDone={() => navigate("/timeline?celebrate=1")} />
        )}
      </div>
    </div>
  );
}
